import * as Yup from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';

export const schema = Yup.object({
  name: Yup.string()
    .trim()
    .min(2, 'Too short')
    .max(30, 'Too long')
    .required('Name is required'),

  mobile_no: Yup.string()
    .required('Mobile number is required')
    .test('is-valid-phone', 'Invalid phone number', (value) => 
      value ? isValidPhoneNumber(value) : false
    ),

  email_id: Yup.string()
    .trim()
    .email('Invalid email address')
    .nullable(),

  address: Yup.string()
    .trim()
    .min(5, 'Too short')
    .required('Address is required'),

  pincode: Yup.string()
    .trim()
    .matches(/^[a-zA-Z0-9\s\-]{3,12}$/, 'Invalid Zip/Postal Code')
    .required('Zip/Postal Code is required'),

  state: Yup.string()
    .trim()
    .required('State is required'),

  city: Yup.string()
    .trim()
    .required('City is required'),
});